import { type ReactNode } from "react";
import { SecondaryNavigation, SecondaryNavigationTitle, Wrapper, type WrapperProps } from "@wfp/ui";

import Breadcrumb from "../Breadcrumb";

type PageStandardBackground = WrapperProps["background"] | string | null;

interface PageStandardProps {
  additional?: ReactNode;
  background?: PageStandardBackground;
  children: ReactNode;
  title: ReactNode;
}

const getWrapperBackground = (background: PageStandardBackground) =>
  background === null ? undefined : (background as WrapperProps["background"] | undefined);

const PageStandard = ({
  additional,
  background = "lighter",
  children,
  title,
}: PageStandardProps) => (
  <>
    <SecondaryNavigation pageWidth="full" additional={additional}>
      <Breadcrumb />
      <SecondaryNavigationTitle>{title}</SecondaryNavigationTitle>
    </SecondaryNavigation>
    <Wrapper pageWidth="full" spacing="md" background={getWrapperBackground(background)}>
      <div className="my-8">{children}</div>
    </Wrapper>
  </>
);

export default PageStandard;
